import {assert} from 'Asserts';
import {makeReactContext} from 'lib/makeReactContext';
import {MethodTaskData, Worksheet, WorksheetViewStateAction} from 'notebook/worksheets/WorksheetConstants';

interface InternalWorksheetContextValue {
  stepCreationContextId: string | null;
  worksheetTaskData: MethodTaskData;
  refetch: () => Promise<void>;
  viewer?: boolean; // Is this being rendered in a readonly context, i.e. printer friendly views
  disableTransitionRunModalCompleteRunButton?: boolean;
  // Are we allowed to execute the Workflow this Worksheet is a part of
  isExecutionEnabled: boolean;

  // Our dispatch to the top level WorksheetView
  dispatch: (action: WorksheetViewStateAction) => void;
}

export interface WorksheetContextValue extends InternalWorksheetContextValue {
  worksheet: Worksheet | null;
}

export interface ValidatedWorksheetContextValue extends WorksheetContextValue {
  worksheet: Worksheet;
}

export function getWorksheetContextFallback(): WorksheetContextValue {
  return {
    stepCreationContextId: null,
    worksheet: null,
    worksheetTaskData: {},
    refetch: () => Promise.resolve(),
    disableTransitionRunModalCompleteRunButton: false,
    isExecutionEnabled: false,
    dispatch: (action) => {},
  };
}

export const WorksheetContext = makeReactContext<WorksheetContextValue>(
  getWorksheetContextFallback,
  'WorksheetContext'
);

export const useValidatedWorksheetContext = (): ValidatedWorksheetContextValue => {
  const context = WorksheetContext.useContext();
  assert(context.worksheet != null, 'Expected Worksheet to be defined');
  // The following is necessary to make TS happy about the validation
  return {...context, worksheet: context.worksheet};
};
